// extracted by mini-css-extract-plugin
export default {"actions":"RevertSquad_actions__ctU4N","btn":"RevertSquad_btn__Up3BG","yes":"RevertSquad_yes__IeRea"};